// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","clearButton":"App_clearButton__2c_vx","finished":"App_finished__12N9T"};